module.exports = __webpack_public_path__ + "img/CIMG1147.4145cf54.jpg";